// Plug-point registry for per-dark-pattern metric tiles.
// Each entry is an array of React components with signature: ({ waveId, wave }) => JSX
// M2/M3/M4 push into these arrays to add their metric tiles to the wave detail page.
const METRIC_TILES = {
    sneaking: [],              // M2 (Wave C) will populate
    interface_interference: [], // M3 (Wave B) will populate
    social_engineering: [],    // M4 (Wave D) will populate
    nagging: [],
    obstruction: [],
};

export default METRIC_TILES;
